import React from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
	{ code: 'es_ES', title: 'español (España)', src: 'es-es.svg' },
	{ code: 'ca_ES', title: 'catalán (España)', src: 'ca-es.svg' },
	{ code: 'eu_ES', title: 'vasco (España)', src: 'eu-es.svg' },
	{ code: 'gl_ES', title: 'gallego (España)', src: 'gl-es.svg' },
	{ code: 'de_DE', title: 'alemán (Alemania)', src: 'de-de.svg' },
	{ code: 'fr_FR', title: 'francés (Francia)', src: 'fr-fr.svg' },
	{ code: 'en_GB', title: 'inglés (Reino Unido)', src: 'en-gb.svg' },
	{ code: 'it_IT', title: 'italiano (Italia)', src: 'it-it.svg' },
];

const BASE_URL =
	'https://des.portalnotarial.es/ancert-portal-ciudadano-home-theme/images/language/';

const LanguageFlags = () => {
	const { i18n } = useTranslation();

	const handleClick = (code) => {
		localStorage.setItem('preferredLanguage', code);
		i18n.changeLanguage(code.split('_')[0]);
	};

	return (
		<ul className="c-pnc-languajesSelector">
			{languages.map(({ code, title, src }) => (
				<li key={code}>
					<button title={title} type="button" onClick={() => handleClick(code)}>
						<img
							src={`${BASE_URL}${src}`}
							alt={title}
							className="c-pnc-languajesSelector__icon"
							onError={(e) => {
								e.currentTarget.src = `${BASE_URL}default.svg`;
							}}
						/>
					</button>
				</li>
			))}
		</ul>
	);
};

export default LanguageFlags;
